import { Box, Flex } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { convertNumberToPx } from '../../../../style/helpers';
import * as styled from './loading-course.styled';
import { CustomSkeleton } from '@components/loading/custom-skeleton/custom-skeleton';
import { LoadingCheckbox } from '@components/loading/loading-route/loading-course/components/loading-checkbox/loading-checkbox';
import { CellCountReturn } from '@components/loading/loading-route/loading-route.types';
import {
    CELL_DIMENSION, CellDimensions,
    GridHeaderHeight
} from '@containers/activity-router/data-grid-container/data-grid-container.styled';

export const LoadingCourse = ({ verticalCellCount }: { verticalCellCount: CellCountReturn }) => {
    const courseHeight = useMemo(() => {
        return convertNumberToPx(verticalCellCount.length * CELL_DIMENSION);
    }, [verticalCellCount]);

    return (
        <Flex>
            <styled.container>
                <Box {...styled.topicFilter} />
                <CustomSkeleton {...styled.course} h={courseHeight} />
            </styled.container>
            <styled.checkboxContainer>
                <Box minH={`calc(${GridHeaderHeight} + ${CellDimensions.h})`} w={'100%'} />
                {verticalCellCount.map((key) => <LoadingCheckbox key={key} />)}
            </styled.checkboxContainer>
        </Flex>
    );
};
